<template>
  <TwoColumnQuizReviewLayout>
    <template #responses>
      <ResponseItem
        v-for="(option) in responses"
        :key="option.id"
        :option="option"
        :showCheckMarkIcon="true"
        :showOrder="true"
        :class="{
          'correct': option.correct,
          'incorrect': !option.correct,
        }"
      />
    </template>
    <template #answers>
      <ResponseItem
        v-for="(option) in answers"
        :key="option.id"
        :showOrder="true"
        :option="option"
        :showCheckMarkIcon="false"
      />
    </template>
  </TwoColumnQuizReviewLayout>
</template>

<script>
import TwoColumnQuizReviewLayout from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/TwoColumnQuizReviewLayout.vue'
import ResponseItem from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/ResponseItem.vue'

export default {
  components: {
    ResponseItem,
    TwoColumnQuizReviewLayout,
  },
  props: {
    dataAnswer: {
      type: Object,
      default: () => {
      },
    },
  },
  computed: {
    answers() {
      return this.dataAnswer?.slideDetails?.SlideOptions
    },
    responses() {
      const vottedAnswerIds = this.dataAnswer?.Answer?.pairs
      if (!vottedAnswerIds || vottedAnswerIds.length === 0) {
        return []
      }
      return vottedAnswerIds.map((id, index) => {
        const res = this.answers.find((answer) => answer.id === id)
        return {
          ...res,
          correct: res.order === index + 1,
        }
      })
    },
  },
}
</script>
